exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gw-auth{padding:24px}@media (min-width:46.25em){.gw-auth{padding:48px 96px;width:36.25em}}.gw-auth__logo{text-align:center}.gw-auth__logo>.gw-logo{width:10.25em;height:2.4375em}.gw-auth__logo:after{display:block;margin:24px auto;width:6.875em;height:.3125em;background-color:#dadada;content:\"\"}.gw-auth-error{margin-top:.75rem;margin-bottom:.75rem;padding:.75rem;background-color:#f8d7da;border-color:#f5c6cb;color:#721c24;font-size:14px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./resources/assets/js/common/authentication/authentication.scss
// module id = uddF
// module chunks = 1